export default {"src":"/oferta/_next/static/media/logo-pink.370d6af9.svg","height":40,"width":224,"blurWidth":0,"blurHeight":0};